import server from "../../plugins/server";
import $f from "../../plugins/functions";
import countries from "../../assets/data/countries.json";
export default {
    namespaced: true,
    state() {
        return {
            warhouseSelected: localStorage.getItem("countryW") || "CI",
            sous_warhouseSelected: localStorage.getItem("sous_countryW") || "all",
            changeW: false,
            changeW_sous: false,
            user: {},
            warhouses: [],
            options: countries,
            warehouses: [],
            warehousesUser: [],
            warehousesSeller: [],
        };
    },

    mutations: {
        changeWrahouse: function (state, payload) {
            if (payload.type == "principal") {
                state.warhouseSelected = payload.warhouse;
                state.changeW = true;
            } else {
                state.sous_warhouseSelected = payload.warhouse;
                state.changeW_sous = true;
            }
        },
        getWarehouses: function (state, payload) {
            state.user = payload.user;
        },
    },
    actions: {
        changeWrahouse(context, payload) {
            context.commit("changeWrahouse", payload);
        },
        async getwharhouseId({ getters }, payload) {
            const resW = await server.get("warehouses", { country: payload.country });
            if (resW.content) return resW.content;
        },
        async getCurrency({ getters, state }, payload) {
            if (state.warehouses && state.warhouseSelected) {
                const dataW = state.warehouses.find(
                    (o) => o.code === state.warhouseSelected
                );
                if (dataW) return dataW.currency;
            }
        },
        async getwharhouseSeller() {
            const resW = await server.get("products", { allWarhouseSeller: true });
            return resW.content;
        },
        async searchUser({ commit }, payload) {
            if (payload.type !== "zone") {
                let typeuser = payload.type;
                if (!Array.isArray(payload.type))
                    typeuser = payload.type[0].toUpperCase() + payload.type.slice(1);

                let filter = {
                    type: typeuser,
                    limit: 10,
                    name: payload.search,
                };

                if (payload.warhouse) filter.countries = payload.warhouse;
                if (typeuser === "Courier") filter.searchByfullName = true;
                const res = await server.find("users", filter);
                if (res.content) return res.content.results;
                else return [];
            } else {
                const filter = {
                    limit: 10,
                    country: payload.warhouse,
                    name: payload.search,
                };
                const res = await server.find("zones", filter);
                if (res.content.results) return res.content.results;
                else return [];
            }
        },
        async searchProducts({ commit }, payload) {
            const filter = {
                limit: 10,
                seller: payload.seller,
                "details.warehouse": payload.warhouse,
                name: payload.search,
            };
            const res = await server.find("products", filter);
            if (res.content && res.content.results) return res.content.results;
            else return [];
        },

        async getWarehouses({ commit, state }, payload) {
            commit("getWarehouses", payload);
            const filter = { limit: 10 };
            state.warehouses = [];
            state.warehousesUser = [];
            if (state.user) {
                if (state.user.countries) {
                    state.warehousesUser = state.user.countries;
                    for (let i in state.warehousesUser) {
                        if (!state.warehousesUser[i].name && !state.warehousesUser[i].code)
                            state.warehousesUser[i] = {
                                name: $f.getCountryNameByCode(
                                    state.options,
                                    state.warehousesUser[i]
                                ),
                                code: state.warehousesUser[i],
                                currency: $f.getCurrencyByCode(
                                    state.options,
                                    state.warehousesUser[i]
                                ),
                            };
                    }
                }
            }

            if (state.warehousesUser.length > 0) {
                state.warehouses = state.warehousesUser;
            } else {
                const res = await server.search("warehouses", filter);
                if (res.content.results) {
                    let data = res.content.results;
                    for (let i in data) {
                        state.warehouses.push({
                            name: $f.getCountryNameByCode(state.options, data[i].country),
                            code: data[i].country,
                            currency: $f.getCurrencyByCode(state.options, data[i].country),
                        });
                    }
                } else state.warehouses = [];
            }
            return state.warehouses;
        },

        async searchPlacementProducts({ commit }, payload) {
            let filter = {
                country: payload.country,
                distinctPlacementProducts: true,
            };
            if (payload.status) filter.status = payload.status;
            if (payload.courier) filter.courier = payload.courier;

            const res = await server.find(payload.table, filter);

            if (res.content && res.content.results) return res.content.results;
            else return [];
        },
    },
    getters: {
        warhouseSelected: (state) => async (data) => {
            if (!state.changeW) {
                if (
                    data.user &&
                    data.user.countries &&
                    data.user.countries.length > 0
                ) {
                    if (data.user.countries.length == 1) {
                        state.warhouseSelected =
                            data.user.countries[0].code || data.user.countries[0];
                        localStorage.setItem("countryW", state.warhouseSelected);
                    }
                    return (
                        localStorage.getItem("countryW") ||
                        data.user.countries[0].code ||
                        data.user.countries[0]
                    );
                }
            }

            return state.warhouseSelected;
        },
        sous_warhouseSelected: (state) => async (data) => {
            if (!state.changeW_sous) {
                if (
                    data.user &&
                    ["Seller", "StockManager", "Administrateur"].indexOf(
                        data.user.type
                    ) == -1
                ) {
                    if (
                        data.user &&
                        data.user.sous_warehouses &&
                        data.user.sous_warehouses.length > 0
                    ) {
                        if (localStorage.getItem("sous_countryW")) {
                            const dataW = data.user.sous_warehouses.find(
                                (o) =>
                                    o._id.toString() === localStorage.getItem("sous_countryW")
                            );
                            if (!dataW && localStorage.getItem("sous_countryW") != "all") {
                                localStorage.setItem(
                                    "sous_countryW",
                                    data.user.sous_warehouses[0]._id.toString()
                                );
                            }
                        } else {
                            localStorage.setItem(
                                "sous_countryW",
                                "all" || data.user.sous_warehouses[0]._id.toString()
                            );
                        }
                        return (
                            localStorage.getItem("sous_countryW") ||
                            "all" ||
                            data.user.sous_warehouses[0]._id.toString()
                        );
                    }
                } else state.sous_warhouseSelected = null;
            }
            return state.sous_warhouseSelected;
        },
        warehouses: (state) => async (data) => {
            const filter = { limit: 10 };
            state.warehousesUser = [];
            state.warehouses = [];
            if (data.user) {
                if (data.user.countries) {
                    state.warehousesUser = data.user.countries;
                    for (let i in state.warehousesUser) {
                        if (!state.warehousesUser[i].name && !state.warehousesUser[i].code)
                            state.warehousesUser[i] = {
                                name: $f.getCountryNameByCode(
                                    state.options,
                                    state.warehousesUser[i]
                                ),
                                code: state.warehousesUser[i],
                                currency: $f.getCurrencyByCode(
                                    state.options,
                                    state.warehousesUser[i]
                                ),
                            };
                    }
                }
            }
            if (state.warehousesUser.length > 0) {
                state.warehouses = state.warehousesUser;
            } else {
                const res = await server.search("warehouses", filter);
                if (res.content.results) {
                    let data = res.content.results;
                    for (let i in data) {
                        state.warehouses.push({
                            name: $f.getCountryNameByCode(state.options, data[i].country),
                            code: data[i].country,
                            currency: $f.getCurrencyByCode(state.options, data[i].country),
                        });
                    }
                } else state.warehouses = [];
            }
            return state.warehouses;
        },
    },
};
